import React, { useEffect } from 'react';

function ConfettiPiece() {
    const [confettiList, setConfettiList] = React.useState([]);

    useEffect(() => {
        


            for (let i = 0; i < 100; i++) {
                const randomRotation = Math.floor(Math.random() * 360);
                const randomScale = Math.random() * 1;
                const randomWidth = Math.floor(
                    Math.random() * Math.max(
                        document.documentElement.clientWidth,
                        window.innerWidth || 0
                    )
                );
                const randomHeight = Math.floor(
                    Math.random() * Math.max(
                        document.documentElement.clientHeight,
                        window.innerHeight || 500
                    )
                );
                const randomAnimationDelay = Math.floor(Math.random() * 15);
                const colors = ['#0CD977', '#FF1C1C', '#FF93DE', '#5767ED', '#FFC61C', '#8497B0'];
                const randomColor = colors[Math.floor(Math.random() * colors.length)];
                const confetti = {
                    top: randomHeight + 'px',
                    right: randomWidth + 'px',
                    backgroundColor: randomColor,
                    opacity: randomScale,
                    transform: `skew(15deg) rotate(${randomRotation}deg)`,
                    animationDelay: `${randomAnimationDelay}s`
                };
                setConfettiList(confettiList => [...confettiList, confetti]);
            }
        
    }, []);

    return (
        <div id="confetti-wrapper">
            {confettiList.map((confetti, i) => (
                <div
                    key={i}
                    className="confetti"
                    style={{
                        top: confetti.top,
                        right: confetti.right,
                        backgroundColor: confetti.backgroundColor,
                        opacity: confetti.opacity,
                        transform: confetti.transform,
                        animationDelay: confetti.animationDelay
                    }}
                />
            ))}
        </div>
    );
}

export default ConfettiPiece;